import React from 'react';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  LineController,
  ScatterController,
  defaults
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import ChartDataLabels from "chartjs-plugin-datalabels";

defaults.font.family = "Fira Sans"

const fechas = {
/*   '15-Feb': { pos: 43, text: ['Inicio votaciones en pleno', 'de informes de comisiones'] }, */
  '14-May': { pos: 62, text: ['Última votación del Pleno', 'de informes de comisiones'] },
  '4-Jul': { pos: 113, text: ['Entrega propuesta de', 'nueva Constitución'] },
  '5-Jul': { pos: 114, text: ['Carta ex Presidente', 'R. Lagos'] },
  '11-Jul': {pos: 120, text: ['', 'Anuncio Bono Invierno']},
  '15-Jul': { pos: 124, text: ['Declaraciones Presidente', 'Gabriel Boric']},
  '23-Jul': { pos: 132, text: ['Carta ex Presidenta', 'M. Bachelet'] }
}

const plugin_image = {
  id: 'customImage',
  afterDatasetsDraw: (chart) => {
    let image = chart.config._config.options.img_decidechile

    const {
      ctx
    } = chart

    ctx.save()
    ctx.globalAlpha = 0.6
    if (image.complete) {
      const ctx = chart.ctx;
      const {
        top,
        left,
        width,
        height
      } = chart.chartArea;
      let image_width = 0.2*image.naturalWidth
      let image_height = 0.2*image.naturalHeight

      if (chart.width < 800){
        image_width = 0.7*image_width
        image_height = 0.7*image_height
      }

      const x = left + width - image_width;
      const y = top + height - image_height;

      ctx.drawImage(image, x, y, image_width, image_height);
    } else {
      image.onload = () => chart.draw();
    }
    ctx.restore()
  }}

const plugin = {
  id: 'corsair',
  afterInit: (chart) => {
    chart.corsair = {
      x: 0,
      y: 0
    }
  },

  afterEvent: (chart, evt) => {
    const {
      chartArea: {
        top,
        bottom,
        left,
        right
      }
    } = chart;
    const {
      x,
      y
    } = evt.event;
    if (x < left || x > right || y < top || y > bottom) {
      chart.corsair = {
        x,
        y,
        draw: false
      }
      chart.draw();
      return;
    }

    chart.corsair = {
      x,
      y,
      draw: true
    }

    chart.draw();
  },
  
  afterDatasetsDraw: (chart, _, opts) => {
    const {
      ctx,
      chartArea: {
        top,
        bottom,
        left,
        right
      }
    } = chart;
    const {
      x,
      y,
      draw
    } = chart.corsair;
    
    if (chart.config._config.data.datasets[0].data.length === 0 && chart.config._config.data.datasets[4].data.length === 0){
      return 
    }

    const datos_rechazo = chart.$context.chart.$datalabels._datasets[1]
    const datos_apruebo = chart.$context.chart.$datalabels._datasets[4]
    const limit_x = 0.85*chart.width

    let delta_final = 200
    let delta_texto = 50
    let delta_upper = 20

    if (chart.width < 800){
      ctx.font = "bold 16px Fira Sans"
      ctx.lineWidth = 2
      delta_final = 50
      delta_texto = 35
      delta_upper = 10
    }
    else{
      ctx.font = "bold 25px Fira Sans"}
      ctx.lineWidth = 4
    
    const apruebo_bool = !document.getElementById("apruebo").classList.contains("clicked")
    const rechazo_bool = !document.getElementById("rechazo").classList.contains("clicked")

    if (!draw) {

      ctx.lineWidth = opts.width || 0;
      ctx.setLineDash(opts.dash || []);
      ctx.strokeStyle = opts.color || 'black'
      ctx.save();
      ctx.beginPath();
      if (opts.vertical) {
        ctx.moveTo(chart.width-delta_final, bottom);
        ctx.lineTo(chart.width-delta_final, top);
      }
      ctx.stroke();

      ctx.strokeStyle = 'white'
      const closest_apruebo = datos_apruebo.at(-1)
      const closest_rechazo = datos_rechazo.at(-1)
      const pos_apruebo = {x: chart.width-delta_final, y: closest_apruebo._el.y}
      const pos_rechazo = {x: chart.width-delta_final, y: closest_rechazo._el.y}

      if (chart.width < 800){
        ctx.font = "8px Fira Sans"
        ctx.lineWidth = 2
      }
      else{
          ctx.font = "12px Fira Sans"}
          ctx.lineWidth = 4

      ctx.fillText(closest_apruebo._el.$context.raw.x, pos_apruebo.x, top)

      if (chart.width < 800){
        ctx.font = "bold 16px Fira Sans"
        ctx.lineWidth = 2
      }
      else{
          ctx.font = "bold 25px Fira Sans"}
          ctx.lineWidth = 4
      
      if (apruebo_bool){
        ctx.strokeText(`${closest_apruebo._el.$context.parsed.y.toFixed(1)}`, pos_apruebo.x, pos_apruebo.y);
        ctx.fillStyle = 'rgba(0, 169, 209, 1)'
        ctx.fillText(`${closest_apruebo._el.$context.parsed.y.toFixed(1)}`, pos_apruebo.x, pos_apruebo.y)

        if (chart.width < 800){
        ctx.font = "10px Fira Sans"
        ctx.lineWidth = 2
        }
        else{
          ctx.font = "14px Fira Sans"}
          ctx.lineWidth = 4

        ctx.strokeText('% Apruebo', pos_apruebo.x+delta_texto, pos_apruebo.y)
        ctx.fillStyle = 'gray'
        ctx.fillText('% Apruebo', pos_apruebo.x+delta_texto, pos_apruebo.y)
      }

      if (chart.width < 800){
        ctx.font = "bold 16px Fira Sans"
        ctx.lineWidth = 2
      }
      else{
          ctx.font = "bold 25px Fira Sans"}
          ctx.lineWidth = 4

      if (rechazo_bool){
        ctx.strokeText(`${closest_rechazo._el.$context.parsed.y.toFixed(1)}`, pos_rechazo.x, pos_rechazo.y)
        ctx.fillStyle = 'rgba(255, 58, 59, 1)';
        /* ctx.fillRect(closest_rechazo._el.x,closest_rechazo._el.y,10,10); // fill in the pixel at (10,10) */
        ctx.fillText(`${closest_rechazo._el.$context.parsed.y.toFixed(1)}`, pos_rechazo.x, pos_rechazo.y)

        if (chart.width < 800){
        ctx.font = "10px Fira Sans"
        ctx.lineWidth = 2
        }
        else{
          ctx.font = "14px Fira Sans"}
          ctx.lineWidth = 4

        ctx.strokeText('% Rechazo', pos_rechazo.x+delta_texto, pos_rechazo.y)
        ctx.fillStyle = 'gray'
        ctx.fillText('% Rechazo', pos_rechazo.x+delta_texto, pos_rechazo.y)
      }
      
      ctx.restore()
      return;
    }

    // DIBUJAR LA LINEA
    ctx.lineWidth = opts.width || 0;
    ctx.setLineDash(opts.dash || []);
    ctx.strokeStyle = opts.color || 'black'
    ctx.save();
    ctx.beginPath();
    if (opts.vertical) {
      ctx.moveTo(x, bottom);
      ctx.lineTo(x, top);
    }
    if (opts.horizontal) {
      ctx.moveTo(left, y);
      ctx.lineTo(right, y);
    }
    ctx.stroke();

    // TEXTO APRUEBO / RECHAZO

    const closest_rechazo =  datos_rechazo.reduce((a, b) => {
      return Math.abs(b._el.x - x) < Math.abs(a._el.x - x) ? b : a;
    });

    const closest_apruebo =  datos_apruebo.reduce((a, b) => {
      return Math.abs(b._el.x - x) < Math.abs(a._el.x - x) ? b : a;
    });

    const pos_apruebo = {x: closest_apruebo._el.x, y: closest_apruebo._el.y}
    const pos_rechazo = {x: closest_rechazo._el.x, y: closest_rechazo._el.y}

    
    if (pos_apruebo.x >= limit_x){
      pos_apruebo.x = limit_x
      pos_rechazo.x = limit_x
    }

     if (chart.width < 800){
        ctx.font = "8px Fira Sans"
        ctx.lineWidth = 2
      }
    else{
        ctx.font = "12px Fira Sans"}
        ctx.lineWidth = 4

    ctx.fillText(closest_apruebo._el.$context.raw.x, x-delta_upper, top)

    if (chart.width < 800){
      ctx.font = "bold 16px Fira Sans"
      ctx.lineWidth = 2
    }
    else{
      ctx.font = "bold 25px Fira Sans"}
      ctx.lineWidth = 4
    ctx.strokeStyle = 'white'

    if (apruebo_bool){
      ctx.strokeText(`${closest_apruebo._el.$context.parsed.y.toFixed(1)}`, pos_apruebo.x, pos_apruebo.y);
      ctx.fillStyle = 'rgba(0, 169, 209, 1)'
      ctx.fillText(`${closest_apruebo._el.$context.parsed.y.toFixed(1)}`, pos_apruebo.x, pos_apruebo.y)

      if (chart.width < 800){
        ctx.font = "10px Fira Sans"
        ctx.lineWidth = 2
      }
      else{
        ctx.font = "14px Fira Sans"}
        ctx.lineWidth = 4
      
      ctx.strokeText('% Apruebo', pos_apruebo.x+delta_texto, pos_apruebo.y)
      ctx.fillStyle = 'gray'
      ctx.fillText('% Apruebo', pos_apruebo.x+delta_texto, pos_apruebo.y)
    }

    if (chart.width < 800){
        ctx.font = "bold 16px Fira Sans"
        ctx.lineWidth = 2
      }
    else{
        ctx.font = "bold 25px Fira Sans"}
        ctx.lineWidth = 4

    if (rechazo_bool){
      ctx.strokeText(`${closest_rechazo._el.$context.parsed.y.toFixed(1)}`, pos_rechazo.x, pos_rechazo.y)
      ctx.fillStyle = 'rgba(255, 58, 59, 1)';
      ctx.fillText(`${closest_rechazo._el.$context.parsed.y.toFixed(1)}`, pos_rechazo.x, pos_rechazo.y)

      if (chart.width < 800){
        ctx.font = "10px Fira Sans"
        ctx.lineWidth = 2
      }
      else{
        ctx.font = "14px Fira Sans"}
        ctx.lineWidth = 4
      
      ctx.strokeText('% Rechazo', pos_rechazo.x+delta_texto, pos_rechazo.y)
      ctx.fillStyle = 'gray'
      ctx.fillText('% Rechazo', pos_rechazo.x+delta_texto, pos_rechazo.y)
    }

    ctx.restore();
  }
}

const vlinePlugin = {
  id: 'vline',
  afterInit: (chart) => {
    chart.corsair = {
      x: 0,
      y: 0
    }
  },

  afterEvent: (chart, evt) => {
    const {
      chartArea: {
        top,
        bottom,
        left,
        right
      }
    } = chart
    const {
      x,
      y
    } = evt.event
    if (x < left || x > right || y < top || y > bottom) {
      chart.corsair = {
        x,
        y,
        draw: false
      }
      chart.draw()
      return
    }

    chart.corsair = {
      x,
      y,
      draw: true
    }

    chart.draw()
  },
  afterDatasetsDraw: chart => {
    const {
      x
    } = chart.corsair

    const nElements = (chart.config._config.data.datasets[0].data.length - 1)
    const chartWidth = chart.chartArea.width
    const chartLeft = chart.chartArea.left
    const widthDiv = chartWidth / nElements

    Object.keys(fechas).forEach(key => {
      const xFecha = widthDiv * fechas[key].pos + chartLeft
      const yAxis = chart.scales.y
      const ctx = chart.ctx
      ctx.save()
      ctx.beginPath()
      ctx.moveTo(xFecha, yAxis.top)
      ctx.lineTo(xFecha, yAxis.bottom)
      ctx.setLineDash([5, 5])
      ctx.lineWidth = 1
      if (Math.abs(x - xFecha) <= 2) {
        ctx.lineWidth = 3
        let defTop = -10
        let defJump = 10
        if (chart.width < 800){
          ctx.font = "bold 8px Fira Sans"
          defTop = -7
          defJump = 7
        }
        else{
          ctx.font = 'bold 12px Fira Sans'
        }
        
        if (x > 0.5 * chartWidth) {
          ctx.direction = 'rtl'
        }
        ctx.lineWidth = 2
        fechas[key].text.forEach((el, idx) => ctx.fillText(`${el}`, xFecha, defTop + yAxis.top + defJump * (idx - 1)))
      }
      ctx.strokeStyle = 'rgba(41, 84, 223, 0.4)'
      ctx.stroke()
      ctx.restore()
    })
  }
}



ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels,
  plugin,
  plugin_image,
  vlinePlugin,
  Filler,
  LineController,
  ScatterController
);


export function EncuestasChart({chartData, options}) {
    

    return (
      <div className = "chart-container">
        <Chart type = "line" options={options} data={chartData} id = "encuestasChart" />
      </div>)
      
}
